import { Enum_Teammember_Gender, TeamMember as TeamMemberEntity } from "@/app/lib/generated/graphql-types";
import { Box, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { notNull } from "@/app/lib/common/not-null";
import EmailButton from "@/app/__to_be_integrated/_____components/_NEW/contact/buttons/EmailButton";
import PhoneButton from "@/app/__to_be_integrated/_____components/_NEW/contact/buttons/PhoneButton";
import MediaView from "@/app/features/shared/media-view/ui/public/MediaView.public";
import { RELATED_INFOS_SPACING } from "@/app/features/shared/related-infos/ui/spacing";

interface TeamMemberProps {
    teamMember: TeamMemberEntity;
}

export default function TeamMember({ teamMember }: TeamMemberProps) {

    const {
        image,
        gender,
        title,
        firstName,
        lastName,
        description,
        email,
        phones
    } = teamMember;
    
    const imageSrc = useMemo(() => {
        if (image) {
            return image;
        }

        switch (gender) {
            case Enum_Teammember_Gender.Female:
                return '/assets/placeholder/placeholder-female-person.webp';
            case Enum_Teammember_Gender.Male:
                return '/assets/placeholder/placeholder-male-person.webp';
            default:
                return '/assets/placeholder/placeholder-female-person.webp';
        }
    }, [image, gender]);

    return (
        <Stack spacing={RELATED_INFOS_SPACING.content} className="team-member-root">
            <Box
                sx={{
                    width: '100%',
                    aspectRatio: '2 / 3',
                    position: 'relative',
                    minHeight: 220,
                }}
            >
                <MediaView
                    src={imageSrc}
                    fill
                    objectFit="cover"
                    objectPosition="center"
                />
            </Box>
            <Typography variant="h2" component="p">{title}&nbsp;{firstName}&nbsp;{lastName}</Typography>
            <Typography variant="subtitle2" component="p">{description}</Typography>

            <Stack spacing={RELATED_INFOS_SPACING.sidebar}>
                <EmailButton email={email} />

                <Stack spacing={RELATED_INFOS_SPACING.content} className="w-full">
                    {phones?.filter(notNull).map((phone, index) => (
                        <div key={index} className="w-full">
                            {phone.reachabilityHint && (
                                <Typography
                                    variant="subtitle2"
                                    component="p"
                                    sx={{ mb: 1}}
                                >
                                    {phone.reachabilityHint}
                                </Typography>
                            )}
                            <PhoneButton phone={phone}/>
                        </div>
                    ))}
                </Stack>
            </Stack>
        </Stack>
    )
}
